import * as THREE from 'three';
import {Canvas2D} from '@/drawings3D/models/Canvas2D';

const Shape = {
	Rectangle:1,
	Triangle:2,
	Circle:3
}
export class BannerContent{
	constructor(bannerStyle, contentArray){
		//contentArray:{text/symbol}
		//bannerStyle: 描述该模板的样式 {content: [{left:top:width:height:}], shape:{boundingWidth:,boundingHeight:, type:rectangle/circle/triangle, radius:/width:/height:/}}
		this.content = new Object();
		var _this = this;
		contentArray.map(item=>{
			_this.content[item.index] = item;
		});
		this.color = bannerStyle.color; //文字颜色
		
		this.backgroundColor = bannerStyle.backgroundColor; //背景文字颜色		
		this.bannerStyle = bannerStyle;
	}

	getDrawingCanvas(){
    	this.canvas = new Canvas2D(this.bannerStyle.boundingWidth, this.bannerStyle.boundingHeight);
    	if (this.bannerStyle.shape.type == Shape.Rectangle){
    		this.canvas.drawRect({x:0,y:0}, 
    			{width: this.bannerStyle.shape.width, height:this.bannerStyle.shape.height,fillColor: this.backgroundColor});
    		//做个白边
    			this.canvas.drawRect({x:4,y:4}, 
    			{width: this.bannerStyle.shape.width - 8, height:this.bannerStyle.shape.height - 8,lineWidth: "4", strokeStyle:'#ffffff'});
    		//读取模板内容
    		var template = this.bannerStyle.shape.template;
    		var _this = this;
    		template.map(item=>{
    			_this.drawContent(item);
    		});
    	}
    	// var sampleDiv = $('#sample');
    	// sampleDiv.empty();
    	// sampleDiv.append(canvas.get());
    	return this.canvas;
		
	}

	drawContent(item){
		if (item.type === 'hor-separator'){
			var endY = this.canvas.height * item.pos;
			this.canvas.drawLine({x:2, y:endY}, {x: this.canvas.width - 2, y: endY}, 
				{lineWidth: 2, color: item.color});
		}
		if (item.type === 'text'){
			var posX = this.canvas.width * item.pos.x;
			var posY = (this.canvas.height * item.pos.y) + item.size;
			this.canvas.drawText(this.content[item.index].text, 
				{x:posX, y: posY}, {color:item.color, size: item.size});
		}
	}
	getBannerWidth(){
		return this.bannerStyle.bannerWidth;
	}

	getBannerHeight(){
		return this.bannerStyle.bannerHeight;
	}

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/BannerContent.js